
import { useEffect, useState } from "react";
import Header from "../Common/Header/Header";
import Swal from "sweetalert2";
// import { skipToken } from "@reduxjs/toolkit/dist/query";
import * as Icons from "heroicons-react";
import { Link } from "react-router-dom";
import SideBar from "../Common/SideBar/SideBar";
import "./Products.css";
// import ProductImportModal from "../Common/Modal/ProductImportModal";
import { Toaster } from "react-hot-toast";
import { FaBarcode } from "react-icons/fa";
import "react-loading-skeleton/dist/skeleton.css";
import ReactPaginate from "react-paginate";
import productPhoto from "../../product.jpg";
import {
  useDeleteProductMutation,
  useProductCountQuery,
  useProductPagenationQuery,
} from "../../services/productApi";
import LoadingModal from "../Common/Modal/LoadingModal";
import ProductBarCodeModal from "../Common/Modal/ProductBarCodeModal";
import ProductPriceModal from "../Common/Modal/ProductPriceModal";
import { signInUser } from "../Utility/Auth";
import { useSelector } from "react-redux";

const Products = (props) => {
  const [show, setShow] = useState(false);
  const [showP, setPShow] = useState(false);
  const lang = useSelector((state) => state.languageReducer);

  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handlePClose = () => setPShow(false);
  const handlePShow = () => setPShow(true);

  const [pageCount, setPageCount] = useState(0);

  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);
  const [q, setQ] = useState("");

  const [barcodeData, setBarCodeData] = useState({});
  // const [productPrice, setProductPrice] = useState({});
  // const [productData, setProductData] = useState({});

  // Price table pop up
  const [selectedProduct, setSelectedProduct] = useState("");

  const auth = signInUser();
  const { aamarId } = auth;

  // get totel product count
  const pageCountQuery = useProductCountQuery({ aamarId });
  useEffect(() => {
    const { data } = pageCountQuery;
    setPageCount(data);
  }, [pageCountQuery]);

  const { data, isLoading, isFetching, refetch } =
    useProductPagenationQuery({
      page,
      size,
      aamarId,
      q,
    });

  console.log('product data', data)
  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);
  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data]);
  // console.log(page, size, q, "Products:", data);

  const [deleteProduct] = useDeleteProductMutation();

  const deleteHandler = async (id) => {
    const result = await Swal.fire({
      title: "Are you Sure?",
      text: "Delete this Product?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const res = await deleteProduct(id);
      if (res) {
        // TODO::
        // add error hendaler for delete error
        console.log(res);
      } else {
        console.log("Delete Operation Canceled by Category!");
        return;
      }
    }
  };
  const handleSearch = (e) => {
    setQ(e.target.value);
  };
  // console.log(pageNo);
  const handlePageClick = (data) => {
    setPage(parseInt(data.selected));
    console.log("Pages cliecked");
  };

  const handleDataLimit = (e) => {
    setSize(parseInt(e.target.value));
    setPage(0); // Reset to first page when size changes
  };



  const handleBarCode = (code, mrp, name) => {
    setBarCodeData({
      code: code,
      mrp: mrp,
      name: name,
    });
    handleShow();
    // console.log(code, name, mrp);
  };

  const handelPriceUpdateModal = (id) => {
    // console.log(productInfo.data)
    setSelectedProduct(id);
    // console.log(productInfo)
    // console.log(id);
    handlePShow();
    // data.refetch()
  };

  return (
    <div>
      <div className="container-fluid ">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.allProducts}></Header>
            <div className="row mt-3">
              <div className="col-md-6">
                <form action="javascript:void(0);">
                  <div className="input-group mb-3 row">
                    <div className="col-md-3">
                      <select
                        className="form-select rounded col-md-2"
                        onChange={(e) => handleDataLimit(e)}
                      >
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="200">200</option>
                        <option value="250">250</option>
                      </select>
                    </div>
                    <div className="col-md-7">
                      <input
                        className="form-control rounded"
                        type="text"
                        placeholder="Search Product . . . . "
                        onKeyUp={(e) => handleSearch(e)}
                      />
                    </div>
                    {/* <input type="text" className="form-control" aria-label="Text input with dropdown button"> */}
                  </div>
                </form>
                {/* Pagenation */}

                <div className="flex justify-center ">
                  <nav aria-label="Page navigation example">
                    <ReactPaginate
                      previousLabel={"<<"}
                      nextLabel={">>"}
                      breakLabel={"..."}
                      //dynamic page count
                      // page count total product / size
                      pageCount={Math.ceil(parseInt(pageCount) / parseInt(size))}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={6}
                      onPageChange={handlePageClick}
                      forcePage={page}
                      containerClassName={"pagination pt-0 pb-2"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                    ></ReactPaginate>
                  </nav>
                </div>
              </div>
              <div className="col-md-6">
                <span className="float-end">
                  {/* <button className='btn btn-dark me-2' onClick={handleShow}><Icons.UploadOutline size={22}></Icons.UploadOutline> Import Product</button> */}
                  <Link
                    className="btn btn-dark mb-2 float-end"
                    to="/product/add"
                  >
                    <Icons.PlusOutline size={22}></Icons.PlusOutline> {lang?.addProduct}
                  </Link>
                  {/* <Link
                    className="btn btn-dark mb-2 float-end me-2"
                    to="/price/import"
                  >
                    <Icons.PlusOutline size={22}></Icons.PlusOutline> Import
                    Price
                  </Link> */}
                  <Link
                    className="btn btn-dark mb-2 float-end me-2"
                    to="/product/import"
                  >
                    <Icons.PlusOutline size={22}></Icons.PlusOutline> {lang?.importProduct}
                  </Link>
                  {/* <Link
                    className="btn btn-dark mb-2 float-end me-2"
                    to="/product/ledger"
                  >
                    <Icons.ChartBarOutline size={22}></Icons.ChartBarOutline>
                    Product Ledger
                  </Link> */}
                </span>
              </div>
            </div>
            <div
              className="table-responsive-sm"
            // style={{ maxHeight: "400px", overflowY: "auto" }}
            >
              <table className="table table-striped ">
                <thead>
                  <tr>
                    <th>BC</th>
                    <th>Photo</th>
                    <th>EAN</th>
                    <th>Name</th>
                    <th>Article Code</th>
                    <th>Category</th>
                    <th>Stock</th>
                    <th>Unit</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    data?.map((product) => (
                      <tr key={product._id}>
                        <td>
                          <FaBarcode
                            onClick={() =>
                              handleBarCode(
                                product.article_code,
                                product?.priceList !== null &&
                                  product?.priceList?.length > 0
                                  ? product.priceList[0].mrp
                                  : 0,
                                product.name
                              )
                            }
                            size={25}
                          />
                        </td>
                        {/* {console.log('photo ',`${encodeURIComponent(product?.photo)}`)} */}
                        <td>
                          <img
                            src={
                              product?.photo
                                ? (product.photo.startsWith("http")
                                  ? product.photo
                                  : `${(process.env.REACT_APP_API_URL || "http://localhost:5001/api/").replace("/api/", "")}${product.photo.startsWith("/") ? "" : "/"}${product.photo}`)
                                : productPhoto
                            }
                            height={50}
                            width={50}
                            onError={(e) => {
                              e.target.src = productPhoto;
                            }}
                          />
                        </td>
                        <td>{product.ean}</td>
                        <td>{product.name}</td>
                        <td>{product.article_code}</td>
                        <td>{product?.category?.name}</td>
                        <td>
                          {product?.currentStock !== undefined
                            ? product.currentStock
                            : (product?.stock ?? 0)}
                        </td>
                        <td>
                          {typeof product?.unit === "object" && product?.unit !== null
                            ? (product.unit.name || product.unit.symbol || "-")
                            : (typeof product?.unit === "string" && !/^[0-9a-fA-F]{24}$/.test(product.unit)
                              ? product.unit
                              : product?.unitName || "-")}
                        </td>
                        {/* <td>{product.mcId}</td> */}
                        <td>
                          <p>
                            <Icons.CurrencyBangladeshiOutline
                              className="icon-mrp"
                              onClick={() =>
                                handelPriceUpdateModal(product._id)
                              }
                              size={20}
                            ></Icons.CurrencyBangladeshiOutline>
                            {/* <Link to={`/product/${product._id}`} target="_blank">
                            <Icons.EyeOutline
                              className="icon-eye"
                              size={20}
                            ></Icons.EyeOutline>
                          </Link> */}

                            <Link
                              to={`/product/update/${product._id}`}
                              target="_blank"
                            >
                              <Icons.PencilAltOutline
                                className="icon-edit"
                                size={20}
                              ></Icons.PencilAltOutline>
                            </Link>
                            {auth?.type === "admin" && (
                              <Icons.TrashOutline
                                className="icon-trash"
                                size={20}
                                onClick={() => deleteHandler(product._id)}
                              />
                            )}
                          </p>
                        </td>
                      </tr>
                    ))
                  ) : (
                    // <tr>
                    //   <td colSpan={6}>
                    //     {isLoading && <Skeleton count={5} />}
                    //     {isFetching && <h2>...isFetching</h2>}
                    //     {error && <h2>Something went wrong</h2>}
                    //   </td>
                    // </tr>
                    // <tr>
                    //   <td colSpan={6}>
                    //     {isLoading && <Skeleton count={100} />}
                    //     {/* {isFetching && <h2>...isFetching</h2>}
                    //     {error && <h2>Something went wrong</h2>} */}
                    //   </td>
                    // </tr>
                    <tr colSpan={9}>No Product Found</tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* pagination */}
            <div className="d-flex justify-content-center bg-red-500">
              <nav aria-label="Page navigation example">
                <ReactPaginate
                  previousLabel={"<<"}
                  nextLabel={">>"}
                  breakLabel={"..."}
                  //dynamic page count
                  // page count total product / size
                  pageCount={Math.ceil(parseInt(pageCount) / parseInt(size))}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={6}
                  onPageChange={handlePageClick}
                  forcePage={page}
                  containerClassName={"pagination pt-0 pb-2"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                ></ReactPaginate>
              </nav>
            </div>
            {/* <ProductDataTable></ProductDataTable> */}
          </div>
        </div>


      </div>
      {/* <ProductImportModal
                show={show}
                handleClose={handleClose}
                handleShow={handleShow}
                handleImportButton={handleImportButton}  
                setCsvData={setCsvData}
            ></ProductImportModal> */}
      <ProductBarCodeModal
        show={show}
        handleClose={handleClose}
        barcodeData={barcodeData}
      ></ProductBarCodeModal>
      {selectedProduct && (
        <ProductPriceModal
          show={showP}
          handleClose={handlePClose}
          animation={false}
          productId={selectedProduct}
        ></ProductPriceModal>
      )}
      <Toaster position="bottom-right" />


    </div>
  );
};

export default Products;
